import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { ForgotService } from '../shared/Forgot.Service';
import { Forgot } from '../shared/forgot.model';
import { AppInsightsService } from '../shared/AppInsights.Service';

@Component({
  selector: 'app-new-pwd',
  templateUrl: './new-pwd.component.html',
  styleUrls: ['./new-pwd.component.scss']
})
export class NewPwdComponent implements OnInit {
  public pass = '';
  public repass = '';
  public message = '';
  public forgot: Forgot;
  public userType: string;
  public mismatchPWD = false;
  public validate = true;
  public isLoading = false;
  public error = false;
  public showPlaceholder: boolean;
  public formErrorFields: any = {
    pass: false,
    invalidPass:false,
    repass: false,
    passmissmatch: false,
	PwdMaxlenthExceed: false
  };

  constructor(private forgotService: ForgotService, private router: Router, private appInsightsService: AppInsightsService) { }

  @ViewChild('pwd') public pwd: ElementRef;
  @ViewChild('pwdc') public pwdc: ElementRef;
  @ViewChild('passInfo') public passInfo: ElementRef;

  ngOnInit() {
  	window.scroll(0, 0);
    this.showPlaceholder = true;
    this.appInsightsService.logEvent("Forgot UI Page - Create Password");
    this.forgotService.getUserType().subscribe(res => {
      this.userType = res;
    });
  }
  
  validatePassword(str) {
	const liElements = this.passInfo.nativeElement.children;
	let valid = true;
	for (let a=0;a< liElements.length;a++) {
		if (liElements[a].className.indexOf('invalid') !== -1) {
			valid = false;
			break;
		}
	}
	return valid;
  }
  
  setPlaceholder(ele) {
    if (this.showPlaceholder) {
      ele.setAttribute('placeholder', ele.getAttribute('data-placeholder'));
    } else {
      ele.setAttribute('placeholder', '');
    }
  }
  
  togglePlaceholder(event: FocusEvent) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
  }

  focusOnInput() {
    let setError = false;
    if (!!this.formErrorFields.pass || !!this.formErrorFields.invalidPass) {
      setError = true;
      setTimeout(() => this.pwd.nativeElement.focus(), 0);
      setTimeout(() => this.pwd.nativeElement.select(), 0);
      window.scrollTo(0,this.pwd.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    } else if (!!this.formErrorFields.repass || !!this.formErrorFields.passmissmatch) {
      setError = true;
      setTimeout(() => this.pwdc.nativeElement.focus(), 0);
      setTimeout(() => this.pwdc.nativeElement.select(), 0);
      window.scrollTo(0,this.pwdc.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    } 
    return setError;
  }

  isErrorPresent() {
    if (!this.formErrorFields.pass && !this.formErrorFields.repass && !this.formErrorFields.passmissmatch) {
      return false;
    } else {
      return true;
    }
  }

  validateAllFields() {
    const fields = ['pass', 'repass'];
    let isErrPresent = false;
    for (let j = 0; j < fields.length; j++) {
      isErrPresent = this.validateInputFields(fields[j]);
      if (isErrPresent) {
        break;
      }
    }
    return isErrPresent;
  }

  ifAtleastOneFieldValidated(model) {
    this.validate = !!this[model] ? false : true;
    return this.validate;
  }
  checkSeq(str){
    const seq = /123|345|456|678|890|111|222|333|444|555|666|777|888|999|000/;
    return seq.test(str);
  }
  validateOnKeyPress(model){
    if(model === 'pass' || model === 'repass'){
	  if (this.pass.length > 24) {
				this.formErrorFields.PwdMaxlenthExceed = true;
				this.formErrorFields.invalidPass = false;
				this.pass = this.pass.slice(0,25);
			} else {
				this.formErrorFields.PwdMaxlenthExceed = false;
			}		
      if(!!this.pass && !!this.repass && this.pass === this.repass){
        this.validateInputFields('repass');
      }
    }
  }
  validateInputFields(model) {
    let error = false;
    this.validate = true;
    if (model === 'pass') {
      if(!this.pass){
        this.formErrorFields.pass = true;
        this.formErrorFields.invalidPass = false;
        error = true;
      } else if (!this.validatePassword(this.pass)) {
        this.formErrorFields.invalidPass = true;
        this.formErrorFields.pass = false;
        error = true;
      } else {
        this.formErrorFields.pass = false;
        this.formErrorFields.invalidPass = false;
        this.ifAtleastOneFieldValidated(model);
      }
     if(this.pass.length>24){
		this.formErrorFields.pass = false;
		this.formErrorFields.invalidPass = false;
		this.formErrorFields.PwdMaxlenthExceed = true;
		error = true;
		}
    }
    if (model === 'repass') {
      if(!this.repass){
        this.formErrorFields.repass = true;
        this.formErrorFields.passmissmatch = false;
        error = true;
      }else if (this.pass !== this.repass) {
        this.formErrorFields.passmissmatch = true;
        this.formErrorFields.repass = false;
        error = true;
      } else {
        this.formErrorFields.passmissmatch = false;
        this.formErrorFields.repass = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }
    if (!!this.pass && !!this.repass && !this.isErrorPresent() && !error) {
      this.validate = error;
    }
    return error;
  }

  onSubmit() {
    this.error = false;
    if(this.checkSeq(this.pass) || !this.validatePassword(this.pass)){
      this.error = true;
      this.message = 'Your new password must be 8 to 24 characters in length, must include an upper case letter, a lower case letter, a number and a special character (such as !,*,#,etc.), and may not include common terms (such as "password", "default", etc.), User ID, previous passwords or character strings (such as abc, 123, etc.).';
      window.scroll(0, 0);
      return;
    }
    if (!this.validateAllFields()) {
      setTimeout(() => {
      	this.error = false;
        this.isLoading = true;
        this.message = '';
        this.validate = true;
      });
      window.scroll(0, 0);
      this.forgotService.updatePass(this.pass, this.userType).subscribe(res => {
        this.forgot = res;
        if (this.forgot) {       
          if (this.forgot.status_code && (this.forgot.status_code !== '200')) {
            setTimeout(() => {
	            this.isLoading = false;
	          });
            window.scroll(0,0);
            this.error = true;
            this.message = this.forgot.message;
            this.validate = false;           
            if (this.forgot.status_code === '420') {
            	this.message = 'Your new password must be 8 to 24 characters in length, must include an upper case letter, a lower case letter, a number and a special character (such as !,*,#,etc.), and may not include common terms (such as "password", "default", etc.), User ID, previous passwords or character strings (such as abc, 123, etc.).';
            }
          } else {
            this.error = false;
          	if (this.forgot.url.length > 0) {
	            if (this.forgot.url === 'eb') {
	              this.forgotService.setUid(this.forgot.userId);
	              this.router.navigate(['/eb']);
	            } else if (this.forgot.url === 'ebbga') {
	              this.router.navigate(['/ebbga']);
	            } else if (this.forgot.url === 'ebe') {
	              this.router.navigate(['/ebe']);
	            } else if (this.forgot.url === 'consultant') {
	              this.router.navigate(['/consultant']);
	            } else if (this.forgot.url === 'epac') {
	              this.router.navigate(['/epac']);
	            } else if (this.forgot.url === 'epp') {
	              this.router.navigate(['/epp']);
	            } else if (this.forgot.url === 'business') {
	              this.router.navigate(['/business']);
	            } else {
	              // redirect to login otherwise route to page and show it on page only.
	              console.log('url ' + this.forgot.url);
	              if (this.forgot.url && this.forgot.url === '/login') {
	                window.location.href = window.location.origin + this.forgot.url;
	              } else {
	              	window.location.href = this.forgot.url;
	              }	              
	            }
	          }
	        } // end else block
        }
      });
    } else {
      this.focusOnInput();
    }
  }
}
